<template>
  <div class="home-page">
    <div class="log-card">
      <div class="shortcut-header">
        <span class="shortcut-title">快捷入口</span>
      </div>
      <div class="shortcut-list">
        <div class="shortcut-item" v-for="item in shortcuts" :key="item.label" @click="handleShortcutClick(item)">
          <el-image
          class="shortcut-icon"
          :src="item.icon"
          fit="cover"></el-image>
          <div class="shortcut-label">{{ item.label }}</div>
        </div>
      </div>
      <div class="log-header">
        <div class="log-title">
          日志信息
          <span class="log-sub">已加载最近10条日志记录，点击</span>
          <el-link type="warning" @click="handleShortcutClick({path: '/personalCenter/userCenter/log'})">查看更多</el-link>
        </div>
      </div>

      <el-table :data="logs" border stripe :header-cell-style="{background: '#fff6e8',color: '#515a6e'}">
        <el-table-column prop="index" label="序号" width="80" align="center"></el-table-column>
        <el-table-column prop="id" label="ID" width="120" align="center"></el-table-column>
        <el-table-column prop="module" label="模块" width="120" align="center"></el-table-column>
        <el-table-column prop="message" label="日志信息" min-width="320" align="center"></el-table-column>
        <el-table-column prop="status" label="操作结果" width="100" align="center">
          <template slot-scope="scope">
            <div :class="[scope.row.status === '成功' ? 'log-success' : 'log-danger']">
                {{ scope.row.status }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="time" label="操作时间" width="160" align="center"></el-table-column>
        <el-table-column prop="ip" label="IP地址" width="150" align="center"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      shortcuts: [
        { icon: require('@/assets/center/log.png'), label: '日志信息', path: '/personalCenter/userCenter/log' },
        { icon: require('@/assets/center/info.png'), label: '修改用户信息', path: '/personalCenter/userCenter/info' },
        { icon: require('@/assets/center/phone.png'), label: '修改手机号码', path: '/personalCenter/userCenter/phone' },
        { icon: require('@/assets/center/email.png'), label: '修改邮箱', path: '/personalCenter/userCenter/email' },
        { icon: require('@/assets/center/password.png'), label: '修改密码', path: '/personalCenter/userCenter/password' },
        { icon: require('@/assets/center/course.png'), label: '我的课程', path: '/personalCenter/trainingSystem/my' },
        { icon: require('@/assets/center/progress.png'), label: '学习进度', path: '/personalCenter/trainingSystem/progress/offline' },
        { icon: require('@/assets/center/check_in.png'), label: '签到打卡', path: '/personalCenter/trainingSystem/clockIn' },
        { icon: require('@/assets/center/grades.png'), label: '成绩查询', path: '/personalCenter/trainingSystem/grade' }
      ],
      logs: [
        {
          index: 1,
          id: '258087',
          module: '登陆模块',
          message: '账号321081191708243774【手机】登陆成功',
          status: '成功',
          time: '2025-12-15 21:38',
          ip: '210.117.227.70'
        },
        {
          index: 2,
          id: '258086',
          module: '登陆模块',
          message: '账号321081191708243774【手机】登陆成功',
          status: '成功',
          time: '2025-12-15 21:30',
          ip: '210.117.227.70'
        },
        {
          index: 3,
          id: '258085',
          module: '登陆模块',
          message: '账号321081191708243774【手机】登陆成功',
          status: '成功',
          time: '2025-12-15 08:58',
          ip: '210.117.227.70'
        },
        {
          index: 4,
          id: '258084',
          module: '登陆模块',
          message: '账号321081191708243774【手机】登陆成功',
          status: '成功',
          time: '2025-12-15 03:38',
          ip: '210.117.227.70'
        },
        {
          index: 5,
          id: '258083',
          module: '登陆模块',
          message: '打开项目成员表',
          status: '失败',
          time: '2025-12-14 17:07',
          ip: '210.117.227.70'
        },
        {
          index: 6,
          id: '258082',
          module: '登陆模块',
          message: '打开项目表成功',
          status: '成功',
          time: '2025-12-11 12:59',
          ip: '210.117.227.70'
        },
        {
          index: 7,
          id: '258081',
          module: '登陆模块',
          message: '账号321081191708243774【手机】登陆成功',
          status: '成功',
          time: '2025-12-10 23:51',
          ip: '210.117.227.70'
        },
        {
          index: 8,
          id: '258080',
          module: '登陆模块',
          message: '账号321081191708243774【手机】登陆成功',
          status: '成功',
          time: '2025-12-10 21:14',
          ip: '210.117.227.70'
        },
        {
          index: 9,
          id: '258079',
          module: '登陆模块',
          message: '保存签到数据【活动ID:518578198】，【联谊课时:16836】',
          status: '成功',
          time: '2025-12-10 05:07',
          ip: '210.117.227.70'
        },
        {
          index: 10,
          id: '258078',
          module: '登陆模块',
          message: '账号321081191708243774【手机】登陆成功',
          status: '成功',
          time: '2025-12-09 18:07',
          ip: '210.117.227.70'
        }
      ]
    }
  },
  methods: {
    handleShortcutClick(item) {
      if (item.path) {
        this.$router.push(item.path)
      } else {
        this.$message.warning('该功能暂未开放')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.home-page {
  min-height: 100%;
  .log-card {
    background: #fff;
    border-radius: 24px;
    padding: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    min-height: 100%;
    .shortcut-header {
      margin-bottom: 12px;

      .shortcut-title {
        font-size: 20px;
        color: #333333;
        font-weight: bold;
        margin-bottom: 16px;
      }
    }

    .shortcut-list {
      display: flex;
      flex-wrap: wrap;
      gap: 63.5px;
      margin-bottom: 24px;
      .shortcut-item {
        // width: 80px;
        text-align: center;
        cursor: pointer;

        .shortcut-icon {
          width: 72px;
          height: 72px;
          margin: 0 auto 8px;
          border-radius: 50%;

          .shortcut-icon-inner {
            width: 38px;
            height: 38px;
            border-radius: 50%;
            background: #ff9800;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
          }
        }

        .shortcut-label {
          font-size: 14px;
          color: #333333;
        }
      }
    }

    .log-header {
      margin-bottom: 10px;

      .log-title {
        font-weight: bold;
        font-size: 20px;
        color: #333333;
        .log-sub {
          font-size: 15px;
          color: #999;
          margin-left: 16px;
          margin-right: 6px;
        }
      }
    }

    .log-success {
      font-size: 14px;
      color: #3aa85b;
    }
    .log-danger {
      font-size: 14px;
      color: #e45c5c;
    }
  }
}
</style>
